import { SbRichTextProps } from '@monoimin/sb-types';

export const validContentRichText = (richText: SbRichTextProps['blok']) => {
  if (
    typeof richText === 'string' ||
    typeof richText?.content === 'string' ||
    !Array.isArray(richText?.content)
  ) {
    return false;
  }

  const firstElement = richText?.content?.[0];
  const lastElement = richText?.content?.[richText?.content?.length - 1];

  if (richText?.content?.length === 1) {
    return Boolean(
      firstElement?.content?.length ||
        firstElement?.text?.length ||
        firstElement?.attrs?.body?.length
    );
  }

  return Boolean(
    (firstElement?.content?.length ||
      firstElement?.text?.length ||
      firstElement?.attrs?.body?.length) &&
      (lastElement?.content?.length ||
        lastElement?.text?.length ||
        lastElement?.attrs?.body?.length ||
        lastElement?.type === 'paragraph')
  );
};

export default validContentRichText;
